import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaYoutube, FaStar } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";

export default function PackageInfo() {
  const [packages, setPackages] = useState([]);
  const [staffWhatsapp, setStaffWhatsapp] = useState(null);
  const user = JSON.parse(localStorage.getItem("user"));
  const username = user?.username || "";

  useEffect(() => {
    fetchPackages();
    fetchStaffWhatsapp();
  }, []);

  // 🔹 Ambil data package dari database
  const fetchPackages = async () => {
    try {
      const res = await fetch("https://api.backofficemain.com/get_packages.php");
      const data = await res.json();
      setPackages(data);
    } catch (err) {
      console.error("Error fetching packages:", err);
    }
  };

  // 🔹 Ambil nomor WhatsApp staff sesuai referal user login
  const fetchStaffWhatsapp = async () => {
    try {
      const res = await fetch("https://api.backofficemain.com/get_staff_whatsapp.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username }),
      });
      const data = await res.json();
      if (data.success && data.whatsapp) setStaffWhatsapp(data.whatsapp);
    } catch (err) {
      console.error("Error fetching staff whatsapp:", err);
    }
  };

  const handleKnowMore = () => {
    if (staffWhatsapp) {
      window.open(`${staffWhatsapp}`, "_blank");
    } else {
      alert("Staff WhatsApp not available yet.");
    }
  };

  return (
    <div className="container py-4">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <button
          className="btn btn-outline-secondary"
          onClick={() => window.history.back()}
        >
          <FaArrowLeft /> Back
        </button>
        <h3 className="text-center flex-grow-1 mb-0 text-danger">
          View Available Mission
        </h3>
      </div>

      {/* Package cards */}
      <div className="row g-4">
        {packages.map((pkg) => {
          const stars = Number(pkg.package_star) || 0; // pastikan integer
          return (
            <div key={pkg.id} className="col-md-6 col-lg-4">
              <div className="card shadow-sm border-0 h-100">
                <div className="card-body">
                  <h5 className="card-title text-danger fw-bold">
                    {pkg.package_name}
                  </h5>

                  {/* 🔸 Tampilkan jumlah bintang dari database */}
                  <div className="mb-2">
                    {[...Array(stars)].map((_, i) => (
                      <FaStar key={i} className="text-warning me-1" />
                    ))}
                  </div>

                  <ul className="list-unstyled small text-secondary">
                    <li>
                      ✅ Profit per like:{" "}
                      <strong className="text-dark">
                        ${pkg.profit_like}
                      </strong>
                    </li>
                    <li>
                      ✅ Profit per view:{" "}
                      <strong className="text-dark">
                        ${pkg.profit_view}
                      </strong>
                    </li>
                    <li>
                      ✅ Auto like/view bot after{" "}
                      <strong className="text-dark">
                        {pkg.duration || 0} hour
                      </strong>
                    </li>
                  </ul>

                  <div className="mt-3">
                    <p className="fw-bold mb-1 text-dark">Withdrawal</p>
                    <p className="mb-1">Min: ${pkg.min_withdraw}</p>
                    <p>Max: ${pkg.max_withdraw}</p>
                  </div>

                  <h4 className="text-success mt-3 fw-bold">
                    ${pkg.price}
                  </h4>
                </div>

                <div className="card-footer bg-white border-0 text-center">
                  <button
                    className="btn btn-outline-danger w-100"
                    onClick={handleKnowMore}
                  >
                    Know more
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
